import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


function Projects() {
  const [added, setAdded] = useState([]);

  // Cards created from the admin page, newest first.
  useEffect(() => {
    fetch("/api/projects")
      .then((res) => (res.ok ? res.json() : { items: [] }))
      .then((data) => setAdded(Array.isArray(data.items) ? data.items : []))
      .catch(() => {});
  }, []);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">AI & Machine Learning Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are some of my recent projects in <strong>Generative AI</strong>, <strong>Large Language Models</strong>, <strong>RAG Systems</strong>, <strong>Deep Learning</strong>, and <strong>Computer Vision</strong>.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {added.map((p) => (
            <Col md={4} className="project-card" key={p.id}>
              <ProjectCard
                imgPath={`/api/projects/${p.id}/image?v=${p.updated}`}
                isBlog={false}
                isOrganizational={p.isOrganizational}
                orgGithubOnly
                title={p.title}
                description={p.description}
                ghLink={p.ghLink}
                demoLink={p.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
